import { ProductTemplate } from '@zopauk/react-components/types/components/styles/Theme';

export const productTemplate: ProductTemplate = {
  title: {
    backgroundColor: '#EEEAE4',
    className: 'font-semibold',
  },
  sectionHeader: {
    className: 'font-semibold',
  },
  subHeading: {
    className: 'font-body',
  },
};
